import React from 'react';
import gql from 'graphql-tag';
import { useIntl } from 'react-intl';
import useQuery from '../../../../modules/react/hooks/useQuery';
import MapboxMapOneFacility from './MapboxMapOneFacility';

export const GET_FACILITY = gql`
  query GetFacility($id: ID!, $locale: String!) {
    facility(id: $id) {
      id
      ...MapFacility
    }
  }
  
  ${MapboxMapOneFacility.fragments.facility}
`;

const MapboxMap = ({ facilityId, ...rest }) => {
  const { locale } = useIntl();
  const { data, loading, error } = useQuery(GET_FACILITY, {
    variables: { id: facilityId, locale },
  });

  if (loading || error) {
    return null;
  }

  const facility = data?.facility || {};

  return (
    <MapboxMapOneFacility
      {...rest}
      facility={facility}
    />
  );
};

export default MapboxMap;
